import pkg from "package.json";

import "./version-message.scss";

const VersionMessage = () => {
  if (import.meta.env.VITE_API_BASE_URL !== "https://api.regt-bot.rs-test.ru") {
    console.log(`v${pkg.version}`);

    return null;
  }

  // TODO add version from env file
  return <div className="version-message">v{pkg.version}</div>;
};

export { VersionMessage };
